import { datadogRum } from '@datadog/browser-rum'

const config = window.Munio.config.datadog

if (config?.rum.applicationId && config?.rum.clientToken) {
  datadogRum.init({
    applicationId: config.rum.applicationId,
    clientToken: config.rum.clientToken,
    site: config.rum.site,
    service: config.service,
    env: config.env,
    version: window.Munio.version,
    sessionSampleRate: config.rum.sessionSampleRate,
    sessionReplaySampleRate: config.rum.sessionReplaySampleRate,
    trackBfcacheViews: true,
    defaultPrivacyLevel: 'allow',
    trackViewsManually: true,
  })

  const name = `/${window.Munio.config.route.path}`.replaceAll(/{[^}]+}/g, '?')
  window.dev.log('[Datadog RUM] startView:', name)
  datadogRum.startView({ name })
}
